/* istanbul ignore file */
import type {CustomCssVarsFnParams, ShouldRenderVarsFnParams} from '@wix/wixstores-client-storefront-common';

export const getResponsiveLayoutCustomCssVars = ({styleParams}: CustomCssVarsFnParams) => {
  return {
    mediaColumnDirection: styleParams.booleans.productPage_flipColumns ? 'row-reverse' : 'row',
  };
};

export const getResponsiveLayoutShouldRenderVars = ({booleans, isMobile}: ShouldRenderVarsFnParams) => {
  return {
    shouldRenderResponsiveLayoutNavigation: booleans.productPage_navigation || isMobile,
  };
};
